import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ExchangeRatesRepository } from '@core/repositories';
import { exchangeRatesActions } from './exchange-rates.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { ErrorResponse } from '@core/models';
import { CookieService } from '@core/services';
import { EXCHANGE_RATES_COOKIE_NAME } from '@data/config';

@Injectable()
export class ExchangeRatesEffects {
  private readonly actions = inject(Actions);

  private readonly cookieService = inject(CookieService);

  private readonly exchangeRatesRepository = inject(ExchangeRatesRepository);

  getCurrencyPairs$ = createEffect(() => {
    return this.actions.pipe(
      ofType(exchangeRatesActions.getCurrencyPairsRequest),
      switchMap(() =>
        this.exchangeRatesRepository.getCurrencyPairs().pipe(
          map(currencyPair => {
            const lee = currencyPair.data.items.find(c => c.base_currency === 'LEE');
            const cheelee = currencyPair.data.items.find(c => c.base_currency === 'CHEEL');
            const coins = { lee: lee?.quotation, cheelee: cheelee?.quotation };
            this.cookieService.set(EXCHANGE_RATES_COOKIE_NAME, JSON.stringify(coins));
            return exchangeRatesActions.getCurrencyPairsSuccess(coins);
          }),
          catchError((error: unknown) => of(exchangeRatesActions.getCurrencyPairsFailure({ error: error as ErrorResponse }))),
        ),
      ),
    );
  });
}
